import React, { useState, useContext } from 'react'
import { postPayment, postProcessor } from '../api/processor';
import { AuthContext } from '../context/AuthContext';
import { getWordOfDictionary } from '../common/dictionary'
import Swal from 'sweetalert2';
import { useNavigate, useLocation } from "react-router";

export const useProcessor = () => {
  const route = useNavigate();

  const [details, setDetails] = useState([]);
  const [products, setProducts] = useState([]);
  const { setLoading, checkToken } = useContext(AuthContext);
  const [request, setRequest] = useState({});


  const createBill = async (datos) => {
    checkToken()
    try {
      setLoading(true);
      const { data } = await postProcessor(datos);
      //console.log(data.data)
      setDetails(data.data)
      setProducts(data.data.products);


      setLoading(false);
      return true;
    } catch (e) {
      setLoading(false);
      //console.log(e);
      return false;
    }
  }

  const processPayment = async (datos, idempotencyKey) => {
    checkToken()
    try {
      setLoading(true);
      let response = await postPayment(datos, idempotencyKey);
      //console.log(response);
      setLoading(false);
      //console.log("No está en el catch")
      //console.log(response)
      return response
    } catch (e) {
      // console.log(e.response)
      setLoading(false);
      if (e.code == "ERR_NETWORK") {
        Swal.fire({
          showCloseButton: true,
          title: 'Advertencia',
          text: "Su solicitud no puede ser procesada",
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#fd6e0d',
          iconColor: "#fd6e0d",
          confirmButtonText: 'Entendido'
        })
      } else {
        if (e.response.data.code == "INSUFFICIENT_BALANCE") {
          Swal.fire({
            showCloseButton: true,
            title: 'Fondos insuficiente',
            text: "¿Quieres pedir un fiado?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#fd6e0d',
            iconColor: "#fd6e0d",
            confirmButtonText: 'Si quiero pedir uno'
          }).then((result) => {
            if (result.isConfirmed) {
              route("/CalcScreen")
            }
        });
        } else {
          Swal.fire({
            showCloseButton: true,
            title: 'Advertencia',
            text: "Su solicitud no puede ser procesada",
            icon: 'warning',
            iconColor: "#fd6e0d",
            showCancelButton: false,
            confirmButtonColor: '#fd6e0d',
            confirmButtonText: 'Entendido'
          })
        }
      }
      // setError(getWordOfDictionary(e.response.data.code));
      return false;
    }
  }

  return {
    products,
    details,
    request,
    createBill,
    processPayment,
    setRequest,
    setDetails
  }
}
